"use client";

import { Alert, Input, Label, TextField } from "@heroui/react";
import { useState } from "react";

import { SubmitButton } from "@/components/auth/submit-button";
import { requestPasswordReset } from "@/lib/auth-client";

export function ForgotPasswordForm() {
  const [submitted, setSubmitted] = useState(false);
  const [isPending, setIsPending] = useState(false);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsPending(true);

    const form = new FormData(event.currentTarget);

    await requestPasswordReset({
      email: String(form.get("email") ?? ""),
      redirectTo: "/reset-password",
    });

    // Always reports success, whether or not the address exists. Reporting
    // "no such account" here would turn this form into a way to enumerate
    // which emails are registered.
    setSubmitted(true);
    setIsPending(false);
  }

  if (submitted) {
    return (
      <Alert status="success">
        <Alert.Content>
          <Alert.Title>Check your inbox</Alert.Title>
          <Alert.Description>
            If that address has an account, a reset link is on its way. It
            expires in an hour.
          </Alert.Description>
        </Alert.Content>
      </Alert>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <TextField name="email" type="email" isRequired autoComplete="email">
        <Label>Email</Label>
        <Input placeholder="you@company.com" />
      </TextField>

      <SubmitButton isPending={isPending}>Send reset link</SubmitButton>
    </form>
  );
}
